<template lang="pug">
global-form-group(
    :edit-toggle="true"
    @toggle_edit='toggle_edit'
	:title="field.title" :field-name="field.name" :show-label="showLabel" )
    div.slotInput(:class="editable ? '' : 'disable-edit'")
        div.wrap-time-native
            button {{ timeLabel }}
            input(:type="editable ? 'time' : 'text'" v-model="time_tmp")

        div.desc.mt-2 {{ field.description }}
</template>

<script>
	import GlobalFormGroup from "../../GlobalFormGroup";
	import moment, { Moment } from 'moment';

	export default  {
		name: "TimeMobile",
		components: {GlobalFormGroup},
		props: {
			field: {

			},

			selected: {
				type: Object,
				default() {
					return {
						value: {
							m: 0,
							h: 12
						}
					}
				}
			}
		},

		data() {
			return {
				time_tmp: '',
				showLabel: false
			}
		},

		computed: {
			timeLabel() {
				var h_tmp = this.selected.value ? this.selected.value.hours: '';
				var m_tmp = this.selected.value ? this.selected.value.minutes: '';

				var timePickerDefault = moment(`${h_tmp}:${m_tmp}:0`, 'H:m:s')

				return timePickerDefault.format('kk:mm');
			},
            editable() {
                return this.store.value[`editable_${this.field.name}`];
            }
		},

		watch: {
			time_tmp(nv) {
				var v = nv ? moment(nv, "kk:mm") : moment();
				this.changePicker(v, '');
			}
		},

		methods: {
			changePicker(value){
				var o = Object.assign({}, this.field, {
					value: {
						hours : value.format("H"),
						minutes : value.format("m"),
					}
				});
				this.$emit('select', o);
			},

            toggle_edit(){
                this.$emit('toggle_edit');
            }
		}
	}
</script>


<style lang="scss">
	.wrap-time-native {
		position: relative;
		button  {
			width: 100%;
			text-align: left;
			border: none;
			border-bottom: 1px solid black;
			padding-left: 0;
			background-color: transparent;
		}
		input {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			z-index: 9;
			height: 100%;
			opacity: 0;
		}
	}
</style>
